import { Auth } from "aws-amplify";

export async function getJwtTokenFromIdToken() {
  const session = await Auth.currentSession();
  return session.getIdToken().getJwtToken();
}
